import { useState } from "react";
import { MYPAGE_DATA_LIMIT } from "../../../../utils/config";
import { Link } from "react-router-dom";
import MypagePagination from "../common/MypagePagination";

const SearchCourseDataTable = ({ tableData, currentPage, setCurrentPage }) => {
  // 1ページの件数
  const [limit] = useState(MYPAGE_DATA_LIMIT);

  // 1ページに表示するデータ
  let dispData = tableData;
  // 表示開始件数
  const offset = (currentPage - 1) * limit;
  dispData = dispData.slice(offset, offset + Number(limit));

  return (
    <>
      {dispData.map((rData) => {
        return (
          <Link
            className="p-search-item"
            to={"../../detail/" + rData.id}
            key={rData.id}
          >
            <div className="p-search-sumb">
              <img
                src={
                  rData.image_src
                    ? rData.image_src
                    : "/common/assets/images/logo02.svg"
                }
                alt={rData.course_name}
              />
            </div>
            <div className="p-search-detail">
              <div className="p-course__courseinfo">
                <ul className="p-search-tag">
                  {rData.categories ? (
                    rData.categories.split(",").map((ctg, index) => {
                      return (
                        <li className="p-course-cat__item" key={index}>
                          {ctg}
                        </li>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </ul>
                {rData.applicant_id ? (
                  <div className="p-course-status">
                    <p className="p-course-status__item">申込中</p>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <h2 className="p-search-detail__ttl">{rData.course_name}</h2>
              <table className="p-search-detail__tbl">
                <tbody>
                  <tr>
                    <th>実施機関</th>
                    <td>{rData.organ}</td>
                  </tr>
                  <tr>
                    <th>実施期間</th>
                    <td>{rData.period}</td>
                  </tr>
                  <tr>
                    <th>申込期間</th>
                    <td>
                      {rData.period_f}～{rData.period_t}
                    </td>
                  </tr>
                  <tr>
                    <th>カテゴリー</th>
                    <td>{rData.keyword}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Link>
        );
      })}
      <MypagePagination
        tableData={tableData}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
};

export default SearchCourseDataTable;
